export default "<div *ngFor=\"let item of data\">\n    {{item.title}}, {{item.number}} \n</div>";